// extracted by mini-css-extract-plugin
module.exports = {"filter":"filter_filter__sw72z","filters":"filter_filters__wr_Wx","icon":"filter_icon__sUuIx"};